// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__3D4oT","skillCont":"Skills_skillCont__21bGr","skillName":"Skills_skillName__3UGdK"};